<template>
  <div class="basic_notice height_fill" @mouseenter="module_isHover(true)" @mouseleave="module_isHover(false)" :style="{
      height: pc_widgets_infor.height + 'px'
    }" ref="wrapper">

    <div class="tooptipPart all_tooptipPart">
      <template v-if="$store.state.app.view_pattern === 'pc'" class="module_edit_btn">
        <my_edit_btn :module="module" tabName="style"></my_edit_btn>
        <my_edit_btn :module="module" tabName="animation"></my_edit_btn>
        <my_close_btn :module="module" :column="column" :moduleIndex="module_index"></my_close_btn>
      </template>
    </div>
    <div class="notice_part" :style="{
      border:borderStyle,
      ...backgroundStyle,
      lineHeight: this.defaultLineHeight
    }">
      <div class="notice_logo" v-show="noticeImgVisible">
        <img :src="listArr.noticeImg"/>
      </div>
      <div class="notice_words" :style="{
        height:this.pc_widgets_infor.font[this.pc_widgets_infor.font.radio_val].fontSize * defaultLineHeight + 'px'
      }">
        <div v-if="isLeft||isRight">
          <p :class="['words_line', 'words-line-'+pc_widgets_infor.direction,isPause?'words_line_pause':'']"
             :data-active="active + ''">{{ listArr.noticeWords }}</p>
        </div>
        <div class="notice-wrapper" v-else>
          <p :class="['words_line', 'words-line-'+pc_widgets_infor.direction]" :data-active="active + ''"
             :style="{...fontStyle}">{{ listArr.noticeWords }}</p>
          <p :class="['words_line', 'words-line-'+pc_widgets_infor.direction]" :data-active="active + ''"
             :style="{...fontStyle}">{{ listArr.noticeWords }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import i18n from '../../language/index'

import {debounce} from "throttle-debounce";

export default {
  name: 'basic_notice',
  data() {
    return {
      defaultLineHeight: 1.6,
      isHover: false,
      init_url: require('@/assets/image/imgadd.jpg'),
      interval: null,
      translateX: 0,
      translateY: 0,
      transition: 0,
      active: false,
      timeoutKeeper: {},
      translateValue: 0,
      isVerticalAniEnd: false,
      $wrapper: $(`#u${this.module.widgets_id}`),
      isPause: false,
      wordLineVisible: true
    };
  },
  props: {
    module: {
      type: Object,
      default: null
    },
    column: {
      type: Object,
      default: null
    },
    row: {
      type: Object,
      default: null
    },
    module_index: {
      type: Number,
      default: 0
    }
  },
  computed: {
    img_effects() {
      return this.module.data.img_effects
    },
    listArr() {
      return this.module.data.listArr
    },
    module_infor() {
      return this.module.data[this.$store.state.app.view_pattern + '_infor'];
    },
    mb_infor() {
      return this.module.data.mb_widgets_infor;
    },
    infor() {
      return this.module.data[this.$store.state.app.view_pattern + '_widgets_infor'];
    },
    pc_widgets_infor() {
      return this.module.data.pc_widgets_infor;
    },
    isLeft() {
      return this.pc_widgets_infor.direction === 'left'
    },
    isRight() {
      return this.pc_widgets_infor.direction === 'right'
    },
    isUp() {
      return this.pc_widgets_infor.direction === 'up'
    },
    isDown() {
      return this.pc_widgets_infor.direction === 'down'
    },
    isIn() {
      return this.pc_widgets_infor.roll_way === 'in'
    },
    isOut() {
      return this.pc_widgets_infor.roll_way === 'out'
    },
    borderStyle() {
      if (this.pc_widgets_infor.border.radio_val === 'hidden') {
        return 'none'
      } else {
        let border = ''
        border += this.pc_widgets_infor.border[this.pc_widgets_infor.border.radio_val].borderStyle + ' '
        border += this.pc_widgets_infor.border[this.pc_widgets_infor.border.radio_val].borderColor + ' '
        border += this.pc_widgets_infor.border[this.pc_widgets_infor.border.radio_val].borderWidth + 'px'
        return border
      }
    },
    borderRadius() {
      return this.pc_widgets_infor.borderRadius[this.pc_widgets_infor.borderRadius.radio_val].value + 'px'
    },
    fontStyle() {
      let fontStyle = {}
      let font = this.pc_widgets_infor.font[this.pc_widgets_infor.font.radio_val]
      fontStyle.fontSize = font.fontSize + 'px'
      fontStyle.fontFamily = font.fontFamily
      fontStyle.lineHeight = this.defaultLineHeight
      if (font.pattern == 'linear_gradient') {
        fontStyle.webkitBackgroundClip = 'text'
        fontStyle.webkitTextFillColor = 'transparent'
        fontStyle.color = ''
        fontStyle.backgroundImage = 'linear-gradient(' + font.linear_gradient.deg + 'deg,' + font.linear_gradient.start_color +
          font.linear_gradient.start_pointer + '%,' + font.linear_gradient.end_color + font.linear_gradient.end_pointer +
          '%)'
      } else {
        fontStyle.color = font.fontColor
      }

      return fontStyle
    },
    aniStyle() {
      let style = {}
      if (this.pc_widgets_infor.direction === 'left' && this.isIn) {
        style.left = '0px'
        this.$wrapper && (style.left = this.$wrapper.find(`.notice_words`).width() + 'px')
      }
      if (this.pc_widgets_infor.direction === 'right' && this.isIn) {
        style.position = 'relative'
        style.right = '0px'
        this.$wrapper && (style.right = this.$wrapper.find(`.words_line`).width() + 'px')
      }
      if (this.pc_widgets_infor.direction === 'left' && this.isOut) {
        style.left = '0px'
      }
      if (this.pc_widgets_infor.direction === 'right' && this.isOut) {
        style.position = 'relative'
        style.right = '0px'
      }
      if (this.pc_widgets_infor.direction === 'left' || this.pc_widgets_infor.direction === 'right') {
        style.transform = 'translateX(' + this.translateX + 'px)'
      } else {
        style.transform = 'translateY(' + this.translateY + 'px)'
      }
      style.transition = 'transform ' + this.transition + 's linear'
      if (this.isHover) {
        style.left = '0px'
      }
      return style
    },
    backgroundStyle() {
      if (this.pc_widgets_infor.background.radio_val === 'hidden') {
        return {
          background: 'transparent'
        }
      }
      return {
        backgroundColor: this.pc_widgets_infor.background[this.pc_widgets_infor.background.radio_val].color,
        backgroundImage: 'url(' + (this.pc_widgets_infor.background[this.pc_widgets_infor.background.radio_val].img || '') + ')',
        backgroundSize: this.pc_widgets_infor.background[this.pc_widgets_infor.background.radio_val].background_size,
        backgroundRepeat: this.pc_widgets_infor.background[this.pc_widgets_infor.background.radio_val].background_repeat,
        backgroundPosition: this.pc_widgets_infor.background[this.pc_widgets_infor.background.radio_val].background_position,
      }
    },
    noticeImgVisible() {
      return this.pc_widgets_infor.noticeImgVisible !== 'default'
    }
  },
  methods: {
    module_isHover(val) {
      this.isHover = val;
      this.handleMouseEnterLeave(this.isHover)
    },
    animateFun() {
      let that = this

      if (this.isHover) {
        that.active = false
      }

      //向左 向右
      if (this.pc_widgets_infor.direction === 'left' || this.pc_widgets_infor.direction === 'right') {
        this.timeoutKeeper[this.getUid()] = setTimeout(() => {
          this.active = true

          let roll_speed = this.pc_widgets_infor.roll_speed

          let contentWidth = this.$wrapper.find(`.notice_words`).width()
          let wordWidth = this.$wrapper.find(`.words_line`).width()

          if (this.isRight) {
            if (this.isIn) {
              this.$wrapper.find(`.notice_words .words_line`).css({
                position: 'relative',
                right: wordWidth,
                left: 'auto'
              })
            } else {
              this.$wrapper.find(`.notice_words .words_line`).css({
                position: 'relative',
                right: 0,
                left: 'auto'
              })
            }
          } else if (this.isLeft) {
            if (this.isIn) {
              this.$wrapper.find(`.notice_words .words_line`).css({
                left: contentWidth
              })
            } else {
              this.$wrapper.find(`.notice_words .words_line`).css({
                left: 0
              })
            }
          }

          if (this.pc_widgets_infor.direction === 'left') {
            if (this.isIn) {
              this.translateX = -(wordWidth + contentWidth)
            } else if (this.isOut) {
              this.translateX = -wordWidth
            }
          } else {
            if (this.isIn) {
              this.translateX = wordWidth + contentWidth
            } else if (this.isOut) {
              this.translateX = contentWidth
            }
          }

          let transition = (Math.abs(this.translateX) / 120) * roll_speed

          this.transition = transition

          this.timeoutKeeper[this.getUid()] = setTimeout(() => {
            this.active = false
          }, (transition + 0.5) * 1000)

          if (this.pc_widgets_infor.roll_loop) {
            clearInterval(this.interval)
            this.interval = setInterval(() => {
              this.active = true
              this.timeoutKeeper[this.getUid()] = setTimeout(() => {
                this.active = false
              }, (transition + 0.5) * 1000)
            }, (transition + 1) * 1000)
          } else {
            this.timeoutKeeper[this.getUid()] = setTimeout(() => {
              this.active = false
              this.$wrapper.find('.words_line').css({
                left: 0,
                right: 'auto'
              })
            }, (transition + 0.5) * 1000)
          }

          this.$wrapper.find('.words_line').css({
            ...this.fontStyle,
            ...this.aniStyle
          })

        })
      } else {
        //向上 向下
        this.timeoutKeeper[this.getUid()] = setTimeout(() => {
          this.active = true
          let roll_speed = this.pc_widgets_infor.roll_speed
          let height = this.$wrapper.find(`.notice_words`).height()

          if (this.pc_widgets_infor.direction === 'up') {
            this.translateY = -height
          } else {
            this.translateY = height
          }
          let transitionSecond = Math.abs(roll_speed / 10 + 0.25)
          if (this.isDown) {
            this.$wrapper.find('.notice-wrapper').css({
              top: -height
            })
          }
          this.aniUpAndDown(transitionSecond)
          clearInterval(this.interval)
          this.interval = setInterval(() => {
            this.aniUpAndDown(transitionSecond)
          }, transitionSecond * 1000 + this.pc_widgets_infor.roll_wait * 1000)
        })
      }
    },
    reAnimate() {
      this.active = false

      clearInterval(this.interval)
      for (let key in this.timeoutKeeper) {
        clearTimeout(this.timeoutKeeper[key])
        delete this.timeoutKeeper[key]
      }
      this.timeoutKeeper[this.getUid()] = setTimeout(() => {
        this.animateFun()
      }, 40)
    },

    debounceReAnimate() {
    },

    handleMouseEnterLeave(isHover) {
      this.isHover = isHover
      if (isHover) {
        this.active = false
        clearInterval(this.interval)
        for (let key in this.timeoutKeeper) {
          clearTimeout(this.timeoutKeeper[key])
          delete this.timeoutKeeper[key]
        }
        if (this.isRight) {
          this.translateX = 0
          this.transition = 0
          this.$wrapper.find('.words-line-right').css({
            ...this.aniStyle,
            left: 0,
          })
        }
        if (this.isLeft || this.isRight) {
          this.$wrapper.find('.words_line').css({
            left: 0,
            transform: 'translateX(0)'
          })
        }
        return
      }
      if (!isHover) {
        this.reAnimate()
      }
    },
    aniUpAndDown(timeSecond) {
      if (this.isUp) {
        this.aniUp(timeSecond)
      } else {
        this.aniDown(timeSecond)
      }
    },
    aniUp(timeSecond) {
      let height = this.$wrapper.find(`.words_line`).height()
      this.$wrapper.find('.notice-wrapper').animate({
        top: -height
      }, timeSecond * 1000, () => {
        this.$wrapper.find('.notice-wrapper .words_line').first().appendTo(this.$wrapper.find('.notice-wrapper'));
        this.$wrapper.find('.notice-wrapper').css({'top': '0'})
      })
    },
    aniDown(timeSecond) {
      let height = this.$wrapper.find(`.words_line`).height()
      this.$wrapper.find('.notice-wrapper').animate({
        top: 0
      }, timeSecond * 1000, () => {
        this.$wrapper.find('.notice-wrapper .words_line').last().prependTo(this.$wrapper.find('.notice-wrapper'));
        this.$wrapper.find('.notice-wrapper').css({'top': -height})
      })
    },
    getUid() {
      return 'u' + Math.ceil(Math.random() * 100000)
    }
  },
  watch: {
    pc_widgets_infor: {
      handler: function (val) {
        this.debounceReAnimate()

        // 设置文字大小后，高度不会马上变化，所以要settimeout。其他的设置直接写同步的代码没问题
        setTimeout(() => {
          if (this.$wrapper.find('.notice_part').outerHeight() > this.pc_widgets_infor.height) {
            this.pc_widgets_infor.height = this.$wrapper.find('.notice_part').outerHeight()
          }
        })

      },
      deep: true
    },
    'listArr.noticeWords'() {
      this.debounceReAnimate()
    },
  },
  mounted() {
    this.$wrapper = $(`#u${this.module.widgets_id}`)
    this.$wrapper.find('.words_line').css(this.fontStyle)
    this.animateFun()
  },
  created() {
    this.debounceReAnimate = debounce(500, false, this.reAnimate.bind(this))
  }
};
</script>

<style lang="scss" scoped>
.basic_notice {
  overflow: hidden;

  .notice_part {
    font-size: 0;

    .notice_logo {
      display: inline-block;
      width: 21px;
      height: 21px;
      vertical-align: middle;
    }

    .notice_words {
      display: inline-block;
      vertical-align: middle;
      position: relative;
      width: calc(100% - 30px);
      overflow: hidden;

      .notice-wrapper {
        position: absolute;
        top: 0;
      }

      .words-line-left, .words-line-right {
        display: table-cell;
        position: relative;
      }

      .words_line {
        white-space: nowrap;

        &[data-active='false'] {
          transform: translateX(0) !important;
          transition: 0s linear !important;
        }

        &[data-active='falseY'] {
          transform: translateY(0px) !important;
          transition: 0s linear !important;
        }

        &.words_line_pause {
          left: 0 !important;
          right: auto !important;
        }
      }

    }
  }
}

</style>



// WEBPACK FOOTER //
// src/widgets/basic_notice/index.vue